import { faGithub, faLinkedinIn, faMediumM } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import Typical from 'react-typical';
import headerImg from '../../images/cv-img-two.png';
import './Header.css';

const Header = () => {
    return (
        <div className="container m-top pb-4">
            <div className="basic-info">
                <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md order-md-2 img-info">
                    <div className="personal-img">
                        <img src={headerImg} alt="" className="img-fluid own-img"/>
                    </div>
                </div>
        
                <div className="col-md-6 main-info header-details">
                    <h3>Hi, I am</h3>
                    <h1>Muhammad Shahnewaz</h1>
                    <h3 className="fw-bold mb-3 d-flex typing-text">
                        I'm a{' '}
                        <Typical 
                            loop={Infinity}
                            wrapper="span"
                            steps={[
                                'Front-end Developer',
                                2000,
                                'React Developer',
                                2000,
                                'JavaScript Developer',
                                2000
                            ]}
                        />
                    </h3>
                    <div className="d-flex icons">
                        <a href="https://www.linkedin.com/in/shahnewaz601/" target="_blank" rel="noreferrer">
                            <FontAwesomeIcon icon={faLinkedinIn}className="fab" />
                        </a>
                        <a href="https://github.com/shahnewaz171" target="_blank" rel="noreferrer">
                            <FontAwesomeIcon icon={faGithub} className="fab" />
                        </a>
                        <a href="https://medium.com/@shahnewaz601" target="_blank" rel="noreferrer">
                            <FontAwesomeIcon icon={faMediumM} className="fab" />
                        </a>
                    </div>
                    <Link to="/about" className="btn btn-outline-custom px-3 mt-4 fw-bold text-white">About Me</Link>
                    <Link to="/contact" className="btn btn-outline-custom px-3 mt-4 fw-bold text-white ms-3">Get in touch</Link>
                </div>
                </div>
            </div>
        </div>
    );
};

export default Header;